import Slider from "./Slider"

export * from "./Slider"

export default Slider
